// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__33-f5","approved":"Status_approved__2qhPk","rejected":"Status_rejected__2qXvG","expired":"Status_expired__1fGKT","label":"Status_label__2rJs4"};